
/* ══════════ tokens cart drawer ══════════
   On Shopify: uses the native Ajax Cart API (/cart.js, /cart/add.js, /cart/change.js)
   and sends "Continue" to /checkout. Product IDs, selling plans and prices are injected
   into window.TOKENS_CART_CONFIG by Liquid. In this preview a local mock returns carts
   in the same shape, so the renderer is identical in both. */
const TK=(()=>{
  const CFG=window.TOKENS_CART_CONFIG||{currency:"USD",checkoutUrl:"/checkout",products:{}};
  const isShopify=!!(window.Shopify&&window.Shopify.shop);
  const fmt=c=>new Intl.NumberFormat("en-US",{style:"currency",currency:CFG.currency}).format(c/100);
  /* Pack size is a VARIANT on this store ("1 tin"/"2 tins"/"3 tins"), not a
     quantity, so a cart line is always quantity 1 and its pack size is read
     back off the variant id. The old per-pack tier table showed the bundle
     price but added qty x the 1-tin variant, which charged more than it said. */
  const packsOf=k=>(CFG.products[k]||{}).packs||{};
  const packOf=(k,q)=>packsOf(k)[Math.min(Math.max(q,1),3)]||packsOf(k)[1]||null;
  const packPrice=(k,mode,q)=>{const p=packOf(k,q);if(!p)return 0;
    return mode==="sub"&&p.subPrice!=null?p.subPrice:p.price;};
  const packIndexOf=(k,variantId)=>{const ps=packsOf(k);
    for(const n of Object.keys(ps)) if(String(ps[n].variantId)===String(variantId)) return +n;
    return 1;};
  const kindOf=it=>{
    for(const k of Object.keys(CFG.products||{})){
      const ps=packsOf(k);
      for(const n of Object.keys(ps)) if(String(ps[n].variantId)===String(it.variant_id)) return k;
      if((CFG.products[k].handle||"")===(it.product_handle||"")) return k;
    }
    return /energy/i.test(it.product_handle||"")?"energy":"sleep";
  };
  /* Two different numbers, and conflating them was the bug behind "6 packs"
     and a 366 total: pack size is which variant the line is (1/2/3 tins), and
     quantity is how many of that pack are in the cart. The drawer used to read
     pack size and ignore it.quantity entirely. */
  const packOfLine=it=>packIndexOf(kindOf(it),it.variant_id);
  const lineQty=it=>Math.max(1,it.quantity||1);
  const tinsOf=it=>packOfLine(it)*lineQty(it);
  const cadence=q=>q===1?"Ships every month":`Ships every ${q} months`;
  /* Only the products Shopify returned. Sleep is a draft product, so there is
     no "sleep" key and anything that assumed both kinds threw on an empty cart. */
  const KINDS=()=>Object.keys(CFG.products||{});
  /* Payment marks in Tokens style: white card, black keyline, red accents.
     Same set as the lander buy box so the cart does not change register. */
  const card=(inner)=>'<svg class="tkc-pmk" viewBox="0 0 40 26" role="img">'+
    '<rect x=".75" y=".75" width="38.5" height="24.5" rx="5" fill="#fff" stroke="#0B0B0B" stroke-width="1.5"/>'+inner+'</svg>';
  const F='font-family:Schibsted Grotesk,Arial,sans-serif';
  const PAY=[
    ["Visa",card(`<text x="20" y="17" text-anchor="middle" style="${F};font-weight:800;font-style:italic;font-size:10.5px;letter-spacing:.4px" fill="#0B0B0B">VISA</text>`)],
    ["Mastercard",card('<circle cx="16" cy="13" r="7" fill="#FB3E4E" stroke="#0B0B0B" stroke-width="1.2"/><circle cx="24" cy="13" r="7" fill="#fff" fill-opacity=".85" stroke="#0B0B0B" stroke-width="1.2"/>')],
    ["American Express",card(`<text x="20" y="16.6" text-anchor="middle" style="${F};font-weight:800;font-size:8.8px;letter-spacing:.3px" fill="#0B0B0B">AMEX</text>`)],
    ["Apple Pay",card(`<path transform="translate(8 6.6) scale(.5)" fill="#0B0B0B" d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9-.7 0-1.8-.8-3-.8-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.5-3.8zM14.2 5.8c.6-.8 1.1-1.8 1-2.8-.9 0-2 .6-2.7 1.4-.6.7-1.1 1.7-1 2.7 1 .1 2-.5 2.7-1.3z"/><text x="19.6" y="16.7" style="${F};font-weight:700;font-size:9px" fill="#0B0B0B">Pay</text>`)],
    ["Google Pay",card(`<text x="8" y="17" style="${F};font-weight:800;font-size:10.5px" fill="#FB3E4E">G</text><text x="16.8" y="16.7" style="${F};font-weight:700;font-size:9px" fill="#0B0B0B">Pay</text>`)],
    ["PayPal",card(`<text x="20" y="16.7" text-anchor="middle" style="${F};font-weight:800;font-style:italic;font-size:9px"><tspan fill="#0B0B0B">Pay</tspan><tspan fill="#FB3E4E">Pal</tspan></text>`)],
    ["Shop Pay",card(`<text x="20" y="16.6" text-anchor="middle" style="${F};font-weight:700;font-size:8.6px" fill="#0B0B0B">shop<tspan font-weight="800" fill="#FB3E4E">Pay</tspan></text>`)]
  ];
  const payHTML=()=>PAY.map(([n,svg])=>`<span title="${n}" aria-label="${n}">${svg}</span>`).join("");
  /* Social proof. The count matches the figure already published on the lander
     and the home page; the quote is a real verified review from that set. */
  const PRESS={quote:"Gummies are out. The new craze is supplement strips.",who:"The Wall Street Journal"};
  const PROOF={count:"1,400+",quote:"It's not a caffeine rush but a steady, focused energy.",who:"Kathryn D."};
  /* An SVG with a viewBox and no width/height fills its container, so if the
     sizing CSS does not reach it the stars render the full width of the panel.
     The intrinsic size lives on the element, never on CSS alone. */
  const STAR='<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true" focusable="false" style="width:12px;height:12px;flex:none;display:block"><path fill="currentColor" stroke="#0B0B0B" stroke-width="1.2" stroke-linejoin="round" d="M12 1.8l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.9l-6.4 3.5L7 14.3l-5.3-5 7.2-.9z"/></svg>';
  const XLABEL={sleep:"For nights",energy:"For afternoons"};
  const an=w=>(/^[aeiou]/i.test(w||"")?"an ":"a ")+w;
  const esc=t=>String(t==null?"":t).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  /* Free tracked delivery threshold, in the cart's own currency. Matches the
     "free over 50" promise the page makes. */
  /* Same conversion issue as the lander: the Shopify threshold is a USD figure
     while cart prices arrive in the market's currency. Derive the rate from a
     price held in both, so a GB cart is not measured against "40" as pounds. */
  const FREE_SHIP=(()=>{
    const k=KINDS()[0], one=k&&packsOf(k)[1];
    const rate=(one&&one.price)?one.price/3499:1;   // 3499 = the 1-tin USD price
    return Math.round(4000*rate);
  })();
  /* The discount row survives a re-render, which replaces the whole footer. */
  const disc={open:false,code:"",msg:"",tone:""};
  const I={
    x:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    bin:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>',
    minus:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    cal:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2"><rect x="3" y="5" width="18" height="15" rx="3"/><path d="M3 9h18M8 3v4M16 3v4"/></svg>',
    moon:'<svg width="15" height="15" viewBox="0 0 24 24"><path d="M20.5 14.6A9 9 0 1 1 9.4 3.5a7.2 7.2 0 0 0 11.1 11.1Z"/></svg>',
    bolt:'<svg width="15" height="15" viewBox="0 0 24 24"><path d="M13.5 1.5 3.8 13.6h6.6l-1.2 8.9 9.9-12.3h-6.8l1.2-8.7Z"/></svg>',
    lock:'<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><rect x="4.5" y="10.5" width="15" height="10.5" rx="3"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></svg>',
    chev:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>',
    shield:'<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"><path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.6 7.5 9.5 4.3-.9 7.5-4.9 7.5-9.5V6Z"/><path d="m8.8 12 2.2 2.2 4.3-4.4" stroke-linecap="round"/></svg>',
    tMoon:'<svg width="22" height="22" viewBox="0 0 24 24" fill="#0b0b0b"><path d="M20.5 14.6A9 9 0 1 1 9.4 3.5a7.2 7.2 0 0 0 11.1 11.1Z"/></svg>',
    tTruck:'<svg width="22" height="22" viewBox="0 0 24 24" fill="#0b0b0b"><path d="M1.5 6.5A1.5 1.5 0 0 1 3 5h10a1.5 1.5 0 0 1 1.5 1.5V9h3.4a2 2 0 0 1 1.6.8l2.6 3.4a2 2 0 0 1 .4 1.2V17a1.5 1.5 0 0 1-1.5 1.5h-.6a3 3 0 0 0-5.8 0H9.4a3 3 0 0 0-5.8 0H3A1.5 1.5 0 0 1 1.5 17Z"/><circle cx="6.5" cy="18.6" r="2.1"/><circle cx="17.5" cy="18.6" r="2.1"/></svg>',
    truckLine:'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>',
    tCheck:'<svg width="22" height="22" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#0b0b0b"/><path d="m7.5 12.3 3 3 6-6.3" fill="none" stroke="#b8f0d8" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  /* ── data layer ── */
  const mock={items:[],seq:1};
  function mockCart(){
    const items=mock.items.map(i=>{
      const k=kindOf(i), pack=packIndexOf(k,i.variant_id), n=Math.max(1,i.quantity||1), mode=i._plan?"sub":"once";
      const unit=packPrice(k,mode,pack), once=packPrice(k,"once",pack);
      return {...i,quantity:n,final_price:unit,final_line_price:unit*n,
        original_price:once,original_line_price:once*n,
        selling_plan_allocation:i._plan?{selling_plan:{id:i._plan,name:(packOf(k,pack)||{}).cadence||cadence(pack)},
          compare_at_price:once,price:unit}:null};
    });
    const total=items.reduce((s,i)=>s+i.final_line_price,0);
    return {items,item_count:items.reduce((s,i)=>s+i.quantity,0),total_price:total,total_discount:0};
  }
  const J={"Content-Type":"application/json",Accept:"application/json"};
  const post=(url,body)=>fetch(url,{method:"POST",headers:J,body:JSON.stringify(body)});
  const addLine=(kind,pack,mode,n)=>{
    const pk=packOf(kind,pack); if(!pk) return null;
    const item={id:pk.variantId,quantity:Math.max(1,n||1)};
    if(mode==="sub"&&pk.sellingPlanId) item.selling_plan=pk.sellingPlanId;
    return post("/cart/add.js",{items:[item]});
  };
  const api=isShopify?{
    get:()=>fetch("/cart.js").then(r=>r.json()),
    add:(kind,pack,mode,n)=>{
      const req=addLine(kind,pack,mode,n);
      return req ? req.then(()=>api.get()) : api.get();
    },
    change:(key,data)=>post("/cart/change.js",{id:key,...data}).then(r=>r.json()),
    /* Switching between subscribe and one-time used to cost three round trips
       (remove, add, re-fetch). /cart/change.js takes a selling_plan and returns
       the whole cart, so the happy path is a single request. The response is
       checked, and anything unexpected falls back to the old two-step path. */
    swap:async(key,kind,pack,mode,n)=>{
      const pk=packOf(kind,pack);
      const qty=Math.max(1,n||1);
      if(pk){
        try{
          const body={id:key,quantity:qty,
            selling_plan:(mode==="sub"&&pk.sellingPlanId)?pk.sellingPlanId:""};
          const r=await post("/cart/change.js",body);
          if(r.ok){
            const c=await r.json();
            const line=(c.items||[]).find(i=>String(i.variant_id)===String(pk.variantId));
            if(line && !!line.selling_plan_allocation===(mode==="sub")) return c;
          }
        }catch(e){}
      }
      /* fallback: add first so the item is never momentarily lost, then drop
         the old line; change.js returns the full cart, so this is two calls. */
      const req=addLine(kind,pack,mode,qty);
      if(req) await req;
      return post("/cart/change.js",{id:key,quantity:0}).then(r=>r.json());
    }
  }:{
    get:async()=>mockCart(),
    add:async(kind,pack,mode,n)=>{const pk=packOf(kind,pack); if(!pk) return mockCart();
      const plan=mode==="sub"?pk.sellingPlanId:null, add=Math.max(1,n||1);
      const hit=mock.items.find(i=>i.variant_id===pk.variantId&&i._plan===plan);
      /* Shopify increments an existing line rather than making a second one */
      if(hit) hit.quantity=(hit.quantity||1)+add;
      else mock.items.push({key:"k"+(mock.seq++),variant_id:pk.variantId,
          product_handle:(CFG.products[kind]||{}).handle,quantity:add,_plan:plan});
      return mockCart();},
    change:async(key,data)=>{const it=mock.items.find(i=>i.key===key);if(!it)return mockCart();
      if("quantity" in data){ if(data.quantity<=0) mock.items=mock.items.filter(i=>i!==it);
        else it.quantity=data.quantity; }
      return mockCart();},
    swap:async(key,kind,pack,mode,n)=>{mock.items=mock.items.filter(i=>i.key!==key);
      return await api.add(kind,pack,mode,n);}
  };

  /* ── view ── */
  const root=document.getElementById("tkcart"); if(!root) return {add(){},open(){}};
  const panel=root.querySelector(".tkc-panel"), body=root.querySelector("[data-body]"), foot=root.querySelector("[data-foot]"), meterEl=root.querySelector("[data-meter]"), nEl=root.querySelector("[data-n]");
  let pendingAdd=false;
  let cart={items:[],item_count:0,total_price:0}, flashKey=null, removed=null, undoTimer=null, lastFocus=null, busy=false;

  /* The real product shot, from the cart line (Shopify sends `image` on every
     line) or from the config for cards that are not in the cart yet. The drawn
     tile is only a last resort when a product has no image set in admin. */
  const drawn=k=>`<div class="tkc-thumb ${k}" aria-hidden="true"><span class="wm wordmark">tokens</span><b>30</b><i>${k==="sleep"?"SLEEP":"ENERGY"}</i></div>`;
  /* Shopify CDN urls already carry a ?v= cache key, so keep it and add width
     rather than rebuilding the url and losing it. */
  const sized=(u,w)=>{ if(!u) return ""; const t=String(u);
    if(/[?&]width=/.test(t)) return t;
    return t+(t.indexOf("?")>-1?"&":"?")+"width="+w; };
  const thumb=(k,src,alt)=>{
    const u=src||(CFG.products[k]||{}).image;
    return u?`<div class="tkc-shot ${k}"><img src="${esc(sized(u,220))}" alt="${esc(alt||"")}" loading="lazy" decoding="async" width="110" height="110"></div>`:drawn(k);
  };
  function itemHTML(it){
    const k=kindOf(it),p=CFG.products[k],sub=!!it.selling_plan_allocation;
    const pack=packOfLine(it), n=lineQty(it), tins=pack*n;
    /* compare_at_price and final_price are per unit, so the whole line is
       each of them times the quantity. */
    const strike=sub?it.selling_plan_allocation.compare_at_price*n:0;
    const unitSave=sub?(it.selling_plan_allocation.compare_at_price-(it.final_price!=null?it.final_price:it.final_line_price/n))
                      :packPrice(k,"once",pack)-packPrice(k,"sub",pack);
    const save=unitSave*n;
    const per=it.final_line_price/(tins*30);
    const packName=`${pack} tin${pack===1?"":"s"}`;
    return `<article class="tkc-item k-${k}${flashKey===it.key?" flash":""}" data-key="${it.key}">
      ${thumb(k,it.image||(it.featured_image||{}).url,p.title)}
      <div class="tkc-main">
        <div class="tkc-row1"><div><h3>${esc(p.title)}</h3><p class="tkc-meta">${esc(p.flavor)} &middot; ${tins*30} ${esc(p.units)} covered</p></div>
          <button class="tkc-rm" data-remove aria-label="Remove ${esc(p.title)}">${I.x}</button></div>
        <div class="tkc-mode" role="group" aria-label="Purchase type">
          <button data-mode="sub" aria-pressed="${sub}">Subscribe${save>0?` <em>save ${fmt(save)}</em>`:""}</button>
          <button data-mode="once" aria-pressed="${!sub}">One-time</button></div>
        <div class="tkc-row2">
          <div class="tkc-step"><button data-dec aria-label="${n<=1?`Remove ${esc(p.title)}`:"One pack fewer"}">${n<=1?I.bin:I.minus}</button><span>${tins} tin${tins===1?"":"s"}</span><button data-inc aria-label="One pack more"${n>=10?" disabled":""}>${I.plus}</button></div>
          <div class="tkc-price">${sub&&strike>it.final_line_price?`<s>${fmt(strike)}</s>`:""}<b>${fmt(it.final_line_price)}</b><small>${fmt(per)} ${an(p.unit)}</small></div>
        </div>
        ${sub?`<p class="tkc-subnote">${I.cal}<span>${esc(it.selling_plan_allocation.selling_plan.name)}. We email you before every charge.</span></p>`:""}
      </div></article>`;
  }
  /* The empty cart uses the same card as the menu drawer and the home page's
     picks, so the drawer does not introduce a third style for the same job. */
  const shortName=t=>String(t||"").replace(/^tokens\s+/i,"");
  function pickHTML(k){
    const p=CFG.products[k], pk=packOf(k,1);
    const on=p.available!==false&&pk&&pk.available!==false;
    const price=packPrice(k,"sub",1);
    return `<div class="tkc-pick ${k}${on?"":" is-soldout"}">
      ${thumb(k,null,p.title)}
      <span class="tx"><small>${esc(XLABEL[k]||"")}</small><b>${esc(shortName(p.title))}</b><em>${esc(p.pitch)}</em></span>
      ${on?`<button class="tkc-pickadd" data-xadd="${k}" data-xmode="sub">Add<small>${fmt(price)}/mo</small></button>`
          :`<span class="tkc-pickout">Sold out</span>`}
    </div>`;
  }
  function xsellHTML(k,mode,label){
    const p=CFG.products[k];
    return `<div class="tkc-xsell ${k}">${thumb(k,null,p.title)}<div><span class="kick">${label||"Complete your day"}</span><h4>${label?p.title:p.x}</h4><p>${p.pitch}</p></div>
      <button class="tkc-add" data-xadd="${k}" data-xmode="${mode}">Add<small>${fmt(packPrice(k,mode,1))}${mode==="sub"?"/mo":""}</small></button></div>`;
  }
  function discHTML(){
    return `<div class="tkc-disc">
      <button type="button" data-disc-toggle aria-expanded="${disc.open}">Add a discount code<i>${I.chev}</i></button>
      <div class="tkc-disc-in"${disc.open?"":" hidden"}>
        <input type="text" data-disc-code value="${esc(disc.code)}" placeholder="Discount code" autocomplete="off" spellcheck="false" enterkeyhint="done">
        <button type="button" data-disc-apply>Apply</button>
      </div>
      ${disc.msg?`<p class="tkc-disc-msg ${disc.tone}">${esc(disc.msg)}</p>`:""}
    </div>`;
  }
  /* Shopify has no Ajax endpoint for discount codes. /discount/<code> puts the
     code on the session, and pointing its redirect at /cart.js means the page
     never navigates. A code we cannot see in cart.js (free shipping, for one)
     is still held on the session and applies at checkout, so never call it bad. */
  async function applyCode(){
    const code=disc.code.trim();
    if(!code){ disc.msg="Enter a code first."; disc.tone="bad"; return render(cart); }
    if(!isShopify){ disc.msg="Preview only. Codes apply on the live store."; disc.tone=""; return render(cart); }
    const before=cart.total_price||0;
    disc.msg="Checking"; disc.tone=""; render(cart);
    try{
      await fetch("/discount/"+encodeURIComponent(code)+"?redirect=/cart.js",{headers:{Accept:"application/json"}});
    }catch(e){
      disc.msg="Network problem. Try again."; disc.tone="bad"; return render(cart);
    }
    await run(api.get());
    const codes=(cart.cart_level_discount_applications||[]).filter(d=>(d.total_allocated_amount||0)>0);
    if(codes.length||(cart.total_price||0)<before){ disc.msg="Code applied."; disc.tone="good"; }
    else { disc.msg="Saved. It will show at checkout if it is valid."; disc.tone=""; }
    render(cart);
  }

  function render(c){
    cart=c;
    const items=c.items, anySub=items.some(i=>i.selling_plan_allocation);
    /* Tins, not packs, so the badge matches what the line says. A 3-tin pack
       reads 3, two of them read 6. */
    const count=items.reduce((s,i)=>s+tinsOf(i),0);
    nEl.textContent=count;
    const pr=root.querySelector("[data-proof]");
    if(pr) pr.innerHTML=`<span class="tkc-hs">${STAR.repeat(5)}</span><span>${PROOF.count} reviews</span>`;
    document.querySelectorAll("[data-cart-count]").forEach(el=>{el.textContent=count;el.hidden=!count;});
    /* Which kinds are in the cart; the cross-sell below still needs this. */
    const t={sleep:0,energy:0}; items.forEach(i=>t[kindOf(i)]+=tinsOf(i)*30);
    /* A thin benefit strip instead of the old token meter, which repeated the
       line item's own "30 afternoons" and took about 70px of height. */
    meterEl.innerHTML=`<div class="tkc-strip">${I.truckLine}<span>In stock. Ships tracked, no signature needed</span></div>`;
    let html="";
    if(removed&&!pendingAdd) html+=`<div class="tkc-undo"><span>Removed ${CFG.products[removed.kind].title}</span><button data-undo>Undo</button></div>`;
    if(items.length){
      html+=items.map(itemHTML).join("");
      const missing=KINDS().filter(k=>!t[k]);
      if(missing.length===1) html+=xsellHTML(missing[0],anySub?"sub":"once");
      else if(!missing.length && KINDS().length>1) html+=`<div class="tkc-sorted"><div class="pair"><span>${I.bolt}</span><span>${I.moon}</span></div><div><b>Day and night, sorted.</b><span class="t">Energy when the afternoon dips, Sleep 30 minutes before bed.</span></div></div>`;
      html+=`<figure class="tkc-proof"><div class="tkc-proof-s">${STAR.repeat(5)}</div>
        <blockquote>${esc(PROOF.quote)}</blockquote>
        <figcaption>${esc(PROOF.who)}<span>Verified buyer</span></figcaption></figure>
      <ul class="tkc-trust">
        <li>${I.tMoon}<b>30-day money back</b></li>
        <li>${I.tTruck}<b>Free over ${fmt(Math.round(FREE_SHIP/100)*100).replace(/[.,]00$/,"")}</b></li>
        <li>${I.tCheck}<b>${anySub?"Cancel anytime":"No subscription"}</b></li></ul>
      ${anySub?"":`<figure class="tkc-press"><blockquote>&ldquo;${esc(PRESS.quote)}&rdquo;</blockquote>
        <figcaption>${esc(PRESS.who)}</figcaption></figure>`}
`;
    } else if(pendingAdd){
      html+=`<article class="tkc-item tkc-skel" aria-live="polite">
        <div class="tkc-shot sk"></div>
        <div class="tkc-main">
          <div class="tkc-row1"><div><h3>Adding to your cart</h3><p class="tkc-meta">One moment</p></div></div>
          <div class="sk-bar"></div><div class="sk-bar short"></div>
        </div></article>`;
    } else {
      html+=`<div class="tkc-empty"><span class="tkc-coin" aria-hidden="true">t</span><h3>Your cart's empty.</h3><p>Pick your token. You've got 30 days to decide.</p>
        <div class="tkc-picks">${KINDS().map(pickHTML).join("")}</div></div>`;
    }
    body.innerHTML=html;
    /* Subtotal is what the packs cost one-time. The subscription saving and any
       discount code are then shown separately, and total_price is already net of
       both, so they are never added together. */
    const sub=items.reduce((s,i)=>s+(i.selling_plan_allocation?i.selling_plan_allocation.compare_at_price*lineQty(i):i.final_line_price),0);
    const lineTotal=items.reduce((s,i)=>s+i.final_line_price,0);
    const savings=sub-lineTotal;
    const codes=(c.cart_level_discount_applications||[]).filter(d=>(d.total_allocated_amount||0)>0);
    const freeShip=c.total_price>=FREE_SHIP;
    foot.hidden=!items.length;
    foot.innerHTML=items.length?`<div class="tkc-lines">
        <div><span>Subtotal</span><span>${fmt(sub)}</span></div>
        ${savings>0?`<div class="save"><span>You save</span><span>-${fmt(savings)}</span></div>`:""}
        ${codes.map(d=>`<div class="save"><span>${esc(d.title)}</span><span>-${fmt(d.total_allocated_amount)}</span></div>`).join("")}
        <div><span>Shipping</span><span class="${freeShip?"free":""}">${freeShip?"Free":"Calculated at checkout"}</span></div></div>
      ${freeShip?"":`<p class="tkc-nudge">${fmt(FREE_SHIP-c.total_price)} away from free tracked delivery</p>`}
      ${discHTML()}
      <button class="tkc-cta" data-continue><span class="l">Continue</span><span class="amt">${fmt(c.total_price)} ${I.chev}</span></button>
      <p class="tkc-fine">${I.shield} Secure checkout. Nothing is charged yet.</p>
      <div class="tkc-pay" aria-label="Accepted payments">${payHTML()}</div>`:"";
    flashKey=null;
  }
  async function run(p){ if(busy)return; busy=true; panel.setAttribute("aria-busy","true");
    try{ render(await p); } finally { busy=false; panel.setAttribute("aria-busy","false"); } }

  /* ── open / close with focus trap ── */
  function open(){ lastFocus=document.activeElement; root.classList.add("open"); root.setAttribute("aria-hidden","false");
    document.documentElement.style.overflow="hidden"; setTimeout(()=>root.querySelector(".tkc-close").focus(),50); }
  function close(){ root.classList.remove("open"); root.setAttribute("aria-hidden","true"); document.documentElement.style.overflow="";
    if(lastFocus&&lastFocus.focus)lastFocus.focus(); }
  root.addEventListener("input",e=>{ if(e.target.matches("[data-disc-code]")) disc.code=e.target.value; });
  root.addEventListener("keydown",e=>{
    if(e.key==="Enter"&&e.target.matches("[data-disc-code]")){ e.preventDefault(); disc.code=e.target.value; applyCode(); return; }
    if(e.key==="Escape")close();
    if(e.key==="Tab"){const f=[...panel.querySelectorAll("button:not([disabled]),a[href]")];if(!f.length)return;const a=f[0],z=f[f.length-1];
      if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}}
  });

  root.addEventListener("click",async e=>{
    const t=e.target.closest("button,[data-close]"); if(!t)return;
    if(t.hasAttribute("data-close"))return close();
    const art=t.closest(".tkc-item"), key=art&&art.dataset.key, it=key&&cart.items.find(i=>i.key===key);
    if(t.hasAttribute("data-remove")&&it){
      removed={kind:kindOf(it),pack:packOfLine(it),n:lineQty(it),mode:it.selling_plan_allocation?"sub":"once"};
      clearTimeout(undoTimer); undoTimer=setTimeout(()=>{removed=null;render(cart);},6000);
      return run(api.change(key,{quantity:0}));
    }
    if(t.hasAttribute("data-inc")&&it){ const n=lineQty(it); if(n>=10) return;
      return run(api.change(key,{quantity:n+1})); }
    if(t.hasAttribute("data-dec")&&it){ const n=lineQty(it);
      if(n<=1){ removed={kind:kindOf(it),pack:packOfLine(it),n:1,mode:it.selling_plan_allocation?"sub":"once"};
        clearTimeout(undoTimer); undoTimer=setTimeout(()=>{removed=null;render(cart);},6000);
        return run(api.change(key,{quantity:0})); }
      return run(api.change(key,{quantity:n-1})); }
    if(t.dataset.mode&&it){ const want=t.dataset.mode, has=it.selling_plan_allocation?"sub":"once"; if(want===has)return;
      /* flip the control immediately so the tap registers; the re-render that
         follows is the source of truth and will correct it if the call fails */
      const grp=t.closest(".tkc-mode");
      if(grp) grp.querySelectorAll("[data-mode]").forEach(b=>
        b.setAttribute("aria-pressed", String(b.dataset.mode===want)));
      return run(api.swap(key,kindOf(it),packOfLine(it),want,lineQty(it))); }
    if(t.hasAttribute("data-undo")&&removed){ const r=removed; removed=null; clearTimeout(undoTimer); return add(r.kind,r.pack,r.mode,false,r.n); }
    if(t.hasAttribute("data-disc-toggle")){ disc.open=!disc.open; disc.msg=""; render(cart);
      if(disc.open){const i=root.querySelector("[data-disc-code]"); if(i)i.focus();} return; }
    if(t.hasAttribute("data-disc-apply")) return applyCode();
    if(t.dataset.xadd) return add(t.dataset.xadd,1,t.dataset.xmode,false);
    if(t.hasAttribute("data-continue")){
      if(isShopify){ t.querySelector(".l").textContent="One moment"; location.href=CFG.checkoutUrl; }
      else { const toast=document.getElementById("toast"); if(toast){toast.textContent="Preview only. On Shopify, Continue goes straight to checkout.";toast.classList.add("show");setTimeout(()=>toast.classList.remove("show"),2600);} }
    }
  });

  async function add(kind,pack,mode,openIt=true,n){
    removed=null; clearTimeout(undoTimer);
    const before=new Set(cart.items.map(i=>i.key+":"+i.variant_id));
    await run(api.add(kind,pack,mode,n));
    const changed=cart.items.find(i=>!before.has(i.key+":"+i.variant_id)&&kindOf(i)===kind);
    if(changed){flashKey=changed.key; render(cart);}
    document.querySelectorAll(".nav .cart").forEach(c=>{c.classList.remove("bump");void c.offsetWidth;c.classList.add("bump");});
    if(openIt)open();
  }
  api.get().then(render);
  return {add,open,close,
    pending:(on)=>{ if(on){ removed=null; clearTimeout(undoTimer); } pendingAdd=!!on; render(cart); },
    refresh:()=>{ pendingAdd=false; return run(api.get()); },
    render:()=>render(cart)};
})();
/* TK is declared with const, so it is a global lexical binding and never a
   property of window. Publish it so feature checks like window.TK work too. */
window.TK=TK;
